/* prettier-ignore */

/* biome-ignore lint/all: This is an auto-generated file */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './_routes/__root'
import { Route as AbmeldenRouteImport } from "./_routes/abmelden";
import { Route as IndexRouteImport } from "./_routes/index";
import { Route as BeratungTaxAdvisoryIdRouteRouteImport } from "./_routes/beratung/$taxAdvisoryId/route";
import { Route as BeratungTaxAdvisoryIdReviewsRouteImport } from "./_routes/beratung/$taxAdvisoryId/reviews";
import { Route as BeratungTaxAdvisoryIdOffenlegungRouteImport } from "./_routes/beratung/$taxAdvisoryId/offenlegung";
import { Route as BeratungTaxAdvisoryIdUnternehmenIndexRouteImport } from "./_routes/beratung/$taxAdvisoryId/unternehmen/index";
import { Route as BeratungTaxAdvisoryIdUnternehmenCompanyIdRouteRouteImport } from "./_routes/beratung/$taxAdvisoryId/unternehmen/$companyId/route";
import { Route as BeratungTaxAdvisoryIdUnternehmenCompanyIdIndexRouteImport } from "./_routes/beratung/$taxAdvisoryId/unternehmen/$companyId/index";
import { Route as BeratungTaxAdvisoryIdUnternehmenCompanyIdReviewRouteImport } from "./_routes/beratung/$taxAdvisoryId/unternehmen/$companyId/review";
import { Route as BeratungTaxAdvisoryIdUnternehmenCompanyIdOffenlegungRouteImport } from "./_routes/beratung/$taxAdvisoryId/unternehmen/$companyId/offenlegung";
import { Route as BeratungTaxAdvisoryIdUnternehmenCompanyIdDokumenteRouteImport } from "./_routes/beratung/$taxAdvisoryId/unternehmen/$companyId/dokumente";

const AbmeldenRoute = AbmeldenRouteImport.update({
  id: "/abmelden",
  path: "/abmelden",
  getParentRoute: () => rootRouteImport,
} as any);
const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any);
const BeratungTaxAdvisoryIdRouteRoute =
  BeratungTaxAdvisoryIdRouteRouteImport.update({
    id: "/beratung/$taxAdvisoryId",
    path: "/beratung/$taxAdvisoryId",
    getParentRoute: () => rootRouteImport,
  } as any);
const BeratungTaxAdvisoryIdReviewsRoute =
  BeratungTaxAdvisoryIdReviewsRouteImport.update({
    id: "/reviews",
    path: "/reviews",
    getParentRoute: () => BeratungTaxAdvisoryIdRouteRoute,
  } as any);
const BeratungTaxAdvisoryIdOffenlegungRoute =
  BeratungTaxAdvisoryIdOffenlegungRouteImport.update({
    id: "/offenlegung",
    path: "/offenlegung",
    getParentRoute: () => BeratungTaxAdvisoryIdRouteRoute,
  } as any);
const BeratungTaxAdvisoryIdUnternehmenIndexRoute =
  BeratungTaxAdvisoryIdUnternehmenIndexRouteImport.update({
    id: "/unternehmen/",
    path: "/unternehmen/",
    getParentRoute: () => BeratungTaxAdvisoryIdRouteRoute,
  } as any);
const BeratungTaxAdvisoryIdUnternehmenCompanyIdRouteRoute =
  BeratungTaxAdvisoryIdUnternehmenCompanyIdRouteRouteImport.update({
    id: "/unternehmen/$companyId",
    path: "/unternehmen/$companyId",
    getParentRoute: () => BeratungTaxAdvisoryIdRouteRoute,
  } as any);
const BeratungTaxAdvisoryIdUnternehmenCompanyIdIndexRoute =
  BeratungTaxAdvisoryIdUnternehmenCompanyIdIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => BeratungTaxAdvisoryIdUnternehmenCompanyIdRouteRoute,
  } as any);
const BeratungTaxAdvisoryIdUnternehmenCompanyIdReviewRoute =
  BeratungTaxAdvisoryIdUnternehmenCompanyIdReviewRouteImport.update({
    id: "/review",
    path: "/review",
    getParentRoute: () => BeratungTaxAdvisoryIdUnternehmenCompanyIdRouteRoute,
  } as any);
const BeratungTaxAdvisoryIdUnternehmenCompanyIdOffenlegungRoute =
  BeratungTaxAdvisoryIdUnternehmenCompanyIdOffenlegungRouteImport.update({
    id: "/offenlegung",
    path: "/offenlegung",
    getParentRoute: () => BeratungTaxAdvisoryIdUnternehmenCompanyIdRouteRoute,
  } as any);
const BeratungTaxAdvisoryIdUnternehmenCompanyIdDokumenteRoute =
  BeratungTaxAdvisoryIdUnternehmenCompanyIdDokumenteRouteImport.update({
    id: "/dokumente",
    path: "/dokumente",
    getParentRoute: () => BeratungTaxAdvisoryIdUnternehmenCompanyIdRouteRoute,
  } as any);

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute;
  "/abmelden": typeof AbmeldenRoute;
  "/beratung/$taxAdvisoryId": typeof BeratungTaxAdvisoryIdRouteRouteWithChildren;
  "/beratung/$taxAdvisoryId/offenlegung": typeof BeratungTaxAdvisoryIdOffenlegungRoute;
  "/beratung/$taxAdvisoryId/reviews": typeof BeratungTaxAdvisoryIdReviewsRoute;
  "/beratung/$taxAdvisoryId/unternehmen/$companyId": typeof BeratungTaxAdvisoryIdUnternehmenCompanyIdRouteRouteWithChildren;
  "/beratung/$taxAdvisoryId/unternehmen/": typeof BeratungTaxAdvisoryIdUnternehmenIndexRoute;
  "/beratung/$taxAdvisoryId/unternehmen/$companyId/dokumente": typeof BeratungTaxAdvisoryIdUnternehmenCompanyIdDokumenteRoute;
  "/beratung/$taxAdvisoryId/unternehmen/$companyId/offenlegung": typeof BeratungTaxAdvisoryIdUnternehmenCompanyIdOffenlegungRoute;
  "/beratung/$taxAdvisoryId/unternehmen/$companyId/review": typeof BeratungTaxAdvisoryIdUnternehmenCompanyIdReviewRoute;
  "/beratung/$taxAdvisoryId/unternehmen/$companyId/": typeof BeratungTaxAdvisoryIdUnternehmenCompanyIdIndexRoute;
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute;
  "/abmelden": typeof AbmeldenRoute;
  "/beratung/$taxAdvisoryId": typeof BeratungTaxAdvisoryIdRouteRouteWithChildren;
  "/beratung/$taxAdvisoryId/offenlegung": typeof BeratungTaxAdvisoryIdOffenlegungRoute;
  "/beratung/$taxAdvisoryId/reviews": typeof BeratungTaxAdvisoryIdReviewsRoute;
  "/beratung/$taxAdvisoryId/unternehmen": typeof BeratungTaxAdvisoryIdUnternehmenIndexRoute;
  "/beratung/$taxAdvisoryId/unternehmen/$companyId/dokumente": typeof BeratungTaxAdvisoryIdUnternehmenCompanyIdDokumenteRoute;
  "/beratung/$taxAdvisoryId/unternehmen/$companyId/offenlegung": typeof BeratungTaxAdvisoryIdUnternehmenCompanyIdOffenlegungRoute;
  "/beratung/$taxAdvisoryId/unternehmen/$companyId/review": typeof BeratungTaxAdvisoryIdUnternehmenCompanyIdReviewRoute;
  "/beratung/$taxAdvisoryId/unternehmen/$companyId": typeof BeratungTaxAdvisoryIdUnternehmenCompanyIdIndexRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  "/": typeof IndexRoute;
  "/abmelden": typeof AbmeldenRoute;
  "/beratung/$taxAdvisoryId": typeof BeratungTaxAdvisoryIdRouteRouteWithChildren;
  "/beratung/$taxAdvisoryId/offenlegung": typeof BeratungTaxAdvisoryIdOffenlegungRoute;
  "/beratung/$taxAdvisoryId/reviews": typeof BeratungTaxAdvisoryIdReviewsRoute;
  "/beratung/$taxAdvisoryId/unternehmen/$companyId": typeof BeratungTaxAdvisoryIdUnternehmenCompanyIdRouteRouteWithChildren;
  "/beratung/$taxAdvisoryId/unternehmen/": typeof BeratungTaxAdvisoryIdUnternehmenIndexRoute;
  "/beratung/$taxAdvisoryId/unternehmen/$companyId/dokumente": typeof BeratungTaxAdvisoryIdUnternehmenCompanyIdDokumenteRoute;
  "/beratung/$taxAdvisoryId/unternehmen/$companyId/offenlegung": typeof BeratungTaxAdvisoryIdUnternehmenCompanyIdOffenlegungRoute;
  "/beratung/$taxAdvisoryId/unternehmen/$companyId/review": typeof BeratungTaxAdvisoryIdUnternehmenCompanyIdReviewRoute;
  "/beratung/$taxAdvisoryId/unternehmen/$companyId/": typeof BeratungTaxAdvisoryIdUnternehmenCompanyIdIndexRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | "/"
    | "/abmelden"
    | "/beratung/$taxAdvisoryId"
    | "/beratung/$taxAdvisoryId/offenlegung"
    | "/beratung/$taxAdvisoryId/reviews"
    | "/beratung/$taxAdvisoryId/unternehmen/$companyId"
    | "/beratung/$taxAdvisoryId/unternehmen/"
    | "/beratung/$taxAdvisoryId/unternehmen/$companyId/dokumente"
    | "/beratung/$taxAdvisoryId/unternehmen/$companyId/offenlegung"
    | "/beratung/$taxAdvisoryId/unternehmen/$companyId/review"
    | "/beratung/$taxAdvisoryId/unternehmen/$companyId/";
  fileRoutesByTo: FileRoutesByTo;
  to:
    | "/"
    | "/abmelden"
    | "/beratung/$taxAdvisoryId"
    | "/beratung/$taxAdvisoryId/offenlegung"
    | "/beratung/$taxAdvisoryId/reviews"
    | "/beratung/$taxAdvisoryId/unternehmen"
    | "/beratung/$taxAdvisoryId/unternehmen/$companyId/dokumente"
    | "/beratung/$taxAdvisoryId/unternehmen/$companyId/offenlegung"
    | "/beratung/$taxAdvisoryId/unternehmen/$companyId/review"
    | "/beratung/$taxAdvisoryId/unternehmen/$companyId";
  id:
    | "__root__"
    | "/"
    | "/abmelden"
    | "/beratung/$taxAdvisoryId"
    | "/beratung/$taxAdvisoryId/offenlegung"
    | "/beratung/$taxAdvisoryId/reviews"
    | "/beratung/$taxAdvisoryId/unternehmen/$companyId"
    | "/beratung/$taxAdvisoryId/unternehmen/"
    | "/beratung/$taxAdvisoryId/unternehmen/$companyId/dokumente"
    | "/beratung/$taxAdvisoryId/unternehmen/$companyId/offenlegung"
    | "/beratung/$taxAdvisoryId/unternehmen/$companyId/review"
    | "/beratung/$taxAdvisoryId/unternehmen/$companyId/";
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  AbmeldenRoute: typeof AbmeldenRoute;
  BeratungTaxAdvisoryIdRouteRoute: typeof BeratungTaxAdvisoryIdRouteRouteWithChildren;
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/abmelden": {
      id: "/abmelden";
      path: "/abmelden";
      fullPath: "/abmelden";
      preLoaderRoute: typeof AbmeldenRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/": {
      id: "/";
      path: "/";
      fullPath: "/";
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/beratung/$taxAdvisoryId": {
      id: "/beratung/$taxAdvisoryId";
      path: "/beratung/$taxAdvisoryId";
      fullPath: "/beratung/$taxAdvisoryId";
      preLoaderRoute: typeof BeratungTaxAdvisoryIdRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/beratung/$taxAdvisoryId/reviews": {
      id: "/beratung/$taxAdvisoryId/reviews";
      path: "/reviews";
      fullPath: "/beratung/$taxAdvisoryId/reviews";
      preLoaderRoute: typeof BeratungTaxAdvisoryIdReviewsRouteImport;
      parentRoute: typeof BeratungTaxAdvisoryIdRouteRoute;
    };
    "/beratung/$taxAdvisoryId/offenlegung": {
      id: "/beratung/$taxAdvisoryId/offenlegung";
      path: "/offenlegung";
      fullPath: "/beratung/$taxAdvisoryId/offenlegung";
      preLoaderRoute: typeof BeratungTaxAdvisoryIdOffenlegungRouteImport;
      parentRoute: typeof BeratungTaxAdvisoryIdRouteRoute;
    };
    "/beratung/$taxAdvisoryId/unternehmen/": {
      id: "/beratung/$taxAdvisoryId/unternehmen/";
      path: "/unternehmen";
      fullPath: "/beratung/$taxAdvisoryId/unternehmen/";
      preLoaderRoute: typeof BeratungTaxAdvisoryIdUnternehmenIndexRouteImport;
      parentRoute: typeof BeratungTaxAdvisoryIdRouteRoute;
    };
    "/beratung/$taxAdvisoryId/unternehmen/$companyId": {
      id: "/beratung/$taxAdvisoryId/unternehmen/$companyId";
      path: "/unternehmen/$companyId";
      fullPath: "/beratung/$taxAdvisoryId/unternehmen/$companyId";
      preLoaderRoute: typeof BeratungTaxAdvisoryIdUnternehmenCompanyIdRouteRouteImport;
      parentRoute: typeof BeratungTaxAdvisoryIdRouteRoute;
    };
    "/beratung/$taxAdvisoryId/unternehmen/$companyId/": {
      id: "/beratung/$taxAdvisoryId/unternehmen/$companyId/";
      path: "/";
      fullPath: "/beratung/$taxAdvisoryId/unternehmen/$companyId/";
      preLoaderRoute: typeof BeratungTaxAdvisoryIdUnternehmenCompanyIdIndexRouteImport;
      parentRoute: typeof BeratungTaxAdvisoryIdUnternehmenCompanyIdRouteRoute;
    };
    "/beratung/$taxAdvisoryId/unternehmen/$companyId/review": {
      id: "/beratung/$taxAdvisoryId/unternehmen/$companyId/review";
      path: "/review";
      fullPath: "/beratung/$taxAdvisoryId/unternehmen/$companyId/review";
      preLoaderRoute: typeof BeratungTaxAdvisoryIdUnternehmenCompanyIdReviewRouteImport;
      parentRoute: typeof BeratungTaxAdvisoryIdUnternehmenCompanyIdRouteRoute;
    };
    "/beratung/$taxAdvisoryId/unternehmen/$companyId/offenlegung": {
      id: "/beratung/$taxAdvisoryId/unternehmen/$companyId/offenlegung";
      path: "/offenlegung";
      fullPath: "/beratung/$taxAdvisoryId/unternehmen/$companyId/offenlegung";
      preLoaderRoute: typeof BeratungTaxAdvisoryIdUnternehmenCompanyIdOffenlegungRouteImport;
      parentRoute: typeof BeratungTaxAdvisoryIdUnternehmenCompanyIdRouteRoute;
    };
    "/beratung/$taxAdvisoryId/unternehmen/$companyId/dokumente": {
      id: "/beratung/$taxAdvisoryId/unternehmen/$companyId/dokumente";
      path: "/dokumente";
      fullPath: "/beratung/$taxAdvisoryId/unternehmen/$companyId/dokumente";
      preLoaderRoute: typeof BeratungTaxAdvisoryIdUnternehmenCompanyIdDokumenteRouteImport;
      parentRoute: typeof BeratungTaxAdvisoryIdUnternehmenCompanyIdRouteRoute;
    };
  }
}

interface BeratungTaxAdvisoryIdUnternehmenCompanyIdRouteRouteChildren {
  BeratungTaxAdvisoryIdUnternehmenCompanyIdDokumenteRoute: typeof BeratungTaxAdvisoryIdUnternehmenCompanyIdDokumenteRoute;
  BeratungTaxAdvisoryIdUnternehmenCompanyIdOffenlegungRoute: typeof BeratungTaxAdvisoryIdUnternehmenCompanyIdOffenlegungRoute;
  BeratungTaxAdvisoryIdUnternehmenCompanyIdReviewRoute: typeof BeratungTaxAdvisoryIdUnternehmenCompanyIdReviewRoute;
  BeratungTaxAdvisoryIdUnternehmenCompanyIdIndexRoute: typeof BeratungTaxAdvisoryIdUnternehmenCompanyIdIndexRoute;
}

const BeratungTaxAdvisoryIdUnternehmenCompanyIdRouteRouteChildren: BeratungTaxAdvisoryIdUnternehmenCompanyIdRouteRouteChildren =
  {
    BeratungTaxAdvisoryIdUnternehmenCompanyIdDokumenteRoute:
      BeratungTaxAdvisoryIdUnternehmenCompanyIdDokumenteRoute,
    BeratungTaxAdvisoryIdUnternehmenCompanyIdOffenlegungRoute:
      BeratungTaxAdvisoryIdUnternehmenCompanyIdOffenlegungRoute,
    BeratungTaxAdvisoryIdUnternehmenCompanyIdReviewRoute:
      BeratungTaxAdvisoryIdUnternehmenCompanyIdReviewRoute,
    BeratungTaxAdvisoryIdUnternehmenCompanyIdIndexRoute:
      BeratungTaxAdvisoryIdUnternehmenCompanyIdIndexRoute,
  };

const BeratungTaxAdvisoryIdUnternehmenCompanyIdRouteRouteWithChildren =
  BeratungTaxAdvisoryIdUnternehmenCompanyIdRouteRoute._addFileChildren(
    BeratungTaxAdvisoryIdUnternehmenCompanyIdRouteRouteChildren,
  );

interface BeratungTaxAdvisoryIdRouteRouteChildren {
  BeratungTaxAdvisoryIdOffenlegungRoute: typeof BeratungTaxAdvisoryIdOffenlegungRoute;
  BeratungTaxAdvisoryIdReviewsRoute: typeof BeratungTaxAdvisoryIdReviewsRoute;
  BeratungTaxAdvisoryIdUnternehmenCompanyIdRouteRoute: typeof BeratungTaxAdvisoryIdUnternehmenCompanyIdRouteRouteWithChildren;
  BeratungTaxAdvisoryIdUnternehmenIndexRoute: typeof BeratungTaxAdvisoryIdUnternehmenIndexRoute;
}

const BeratungTaxAdvisoryIdRouteRouteChildren: BeratungTaxAdvisoryIdRouteRouteChildren =
  {
    BeratungTaxAdvisoryIdOffenlegungRoute:
      BeratungTaxAdvisoryIdOffenlegungRoute,
    BeratungTaxAdvisoryIdReviewsRoute: BeratungTaxAdvisoryIdReviewsRoute,
    BeratungTaxAdvisoryIdUnternehmenCompanyIdRouteRoute:
      BeratungTaxAdvisoryIdUnternehmenCompanyIdRouteRouteWithChildren,
    BeratungTaxAdvisoryIdUnternehmenIndexRoute:
      BeratungTaxAdvisoryIdUnternehmenIndexRoute,
  };

const BeratungTaxAdvisoryIdRouteRouteWithChildren =
  BeratungTaxAdvisoryIdRouteRoute._addFileChildren(
    BeratungTaxAdvisoryIdRouteRouteChildren,
  );

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AbmeldenRoute: AbmeldenRoute,
  BeratungTaxAdvisoryIdRouteRoute: BeratungTaxAdvisoryIdRouteRouteWithChildren,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
